module.exports = __webpack_public_path__ + "static/img/说明文字.1c5b2155.png";